import * as yup from 'yup';

interface DeductionsAndGiftsFormValues {
  administrationExpenseDeductionAmount: number;
  lifetimeGiftingExemptionUsedAmount: number;
}
export interface DeductionsAndGiftsValues {
  principal: DeductionsAndGiftsFormValues;
  spouse?: Partial<DeductionsAndGiftsFormValues>;
}

export const deductionsValidation = yup.object().shape({
  principal: yup.object().shape({
    administrationExpenseDeductionAmount: yup
      .string()
      .required('Administration expense deduct amount is required.'),
    lifetimeGiftingExemptionUsedAmount: yup
      .string()
      .nullable()
      .required('Lifetime gifting exemption used amount is required.'),
  }),
  spouse: yup.object().when('$showPartnerSection', {
    is: true,
    then: yup.object().shape({
      administrationExpenseDeductionAmount: yup
        .string()
        .required('Administration expense deduct amount is required.'),
      lifetimeGiftingExemptionUsedAmount: yup
        .string()
        .nullable()
        .required('Lifetime gifting exemption used amount is required.'),
    }),
  }),
});
